import { Skeleton } from '@/shared/components/ui/skeleton';
import { Separator } from '@/shared/components/ui/separator';

export function OrgInfoSkeleton() {
  return (
    <div className="space-y-8" data-testid="settings-org-info-skeleton">
      {/* Section 1 — organization data */}
      <div>
        <div className="pb-6 space-y-1.5">
          <Skeleton className="h-6 w-40" />
          <Skeleton className="h-4 w-72" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-[140px_1fr] gap-8 items-start">
          <div className="flex justify-center">
            <div className="relative">
              <Skeleton className="size-[60px] md:size-[100px] rounded-xl" />
              <Skeleton className="absolute bottom-1 right-1 size-7 rounded-full" />
            </div>
          </div>
          <div className="space-y-6">
            <div className="space-y-3">
              <Skeleton className="h-4 w-12" />
              <Skeleton className="size-8 rounded-full" />
            </div>
            <Skeleton className="h-9 w-full" />
            <Skeleton className="h-9 w-full" />
            <Skeleton className="h-20 w-full" />
            <Skeleton className="h-9 w-full" />
          </div>
        </div>
        <div className="flex justify-end mt-10">
          <Skeleton className="h-9 w-28" />
        </div>
      </div>

      <Separator />

      {/* Section 2 — plan & limits */}
      <div>
        <div className="pb-6 space-y-1.5">
          <Skeleton className="h-6 w-32" />
          <Skeleton className="h-4 w-56" />
        </div>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-12" />
          </div>
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-4 w-6" />
          </div>
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-6" />
          </div>
        </div>
      </div>
    </div>
  );
}
